<div class="w-full max-w-[800px] p-0">

  <!-- Header -->
  <div style="display: flex; align-items: center; gap: 12px; padding: 20px 24px; border-bottom: 1px solid #e5e7eb;">
    <div style="background: #fee2e2; border-radius: 12px; padding: 10px; display: flex; align-items: center; justify-content: center;">
      <mat-icon style="color: #dc2626; font-size: 24px; width: 24px; height: 24px;">block</mat-icon>
    </div>
    <div>
      <h2 style="margin: 0; font-size: 1.2rem; font-weight: 700; color: #111827;">Rechazar transferencia</h2>
      <p style="margin: 2px 0 0 0; font-size: 0.8rem; color: #6b7280;">Indique el motivo del rechazo</p>
    </div>
  </div>

  <!-- C1: FIAT_VES_CLP sin cardexId no se rechaza (caía a la lambda y abonaba VES como CLP) -->
  <div *ngIf="faltaCardexVes" role="alert" data-test="falta-cardex-ves"
    class="flex items-start gap-3 mx-4 sm:mx-6 mt-4 p-3 rounded-lg border border-amber-200 bg-amber-50 text-amber-900 text-sm">
    <mat-icon class="text-amber-600 shrink-0">warning</mat-icon>
    <span class="min-w-0">{{ mensajeFaltaCardexVes }}</span>
  </div>

  <!-- Form -->
  <div style="padding: 20px 24px;" *ngIf="datosForm">
    <form [formGroup]="datosForm">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Motivo del rechazo</mat-label>
        <mat-icon matPrefix style="color: #dc2626; margin-right: 8px;">report_problem</mat-icon>
        <mat-select required formControlName="motivo">
          <mat-option>Motivo del rechazo</mat-option>
          <mat-option *ngFor="let motivo of motivosRechazo" [value]="motivo">
            {{ motivo }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Descripción del rechazo</mat-label>
        <mat-icon matPrefix style="color: #6b7280; margin-right: 8px;">notes</mat-icon>
        <textarea matInput formControlName="comentario" maxlength="100" #input placeholder="Opcional"></textarea>
        <mat-hint align="end">{{ input.value.length }}/100</mat-hint>
      </mat-form-field>
    </form>
  </div>

  <!-- Buttons -->
  <div style="display: flex; gap: 12px; padding: 20px 24px; border-top: 1px solid #e5e7eb; justify-content: flex-end;">
    <button (click)="close()"
      style="padding: 10px 24px; background: #f3f4f6; color: #374151; border: none; border-radius: 8px; font-size: 0.9rem; font-weight: 600; cursor: pointer;">
      Cancelar
    </button>
    <button (click)="rejectTransaction()" [disabled]="datosForm?.invalid || faltaCardexVes" data-test="btn-rechazar"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: #dc2626; color: white; border: none; border-radius: 8px; font-size: 0.9rem; font-weight: 600; cursor: pointer;"
      [style.opacity]="datosForm?.invalid || faltaCardexVes ? '0.5' : '1'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px;">block</mat-icon>
      Rechazar
    </button>
  </div>

</div>
